// 电脑端入口页

import { useState, useEffect } from 'react'
import RouterConfig from './common/router_config'
import { HashRouter } from 'react-router-dom'
import './styles/common.css'
import './App.css'
import 'antd/dist/antd.css'
import Login from './components/login/index'
import Menu from './components/menu/index'
import { ConfigProvider, BackTop } from 'antd'
import { UpCircleOutlined, PoweroffOutlined, ExperimentOutlined } from '@ant-design/icons';
import url from './common/url_config'
import fun from './common/common_fun'
import zhCN from 'antd/es/locale/zh_CN';
import cookie from 'react-cookies'

function App() {
  let [role, set_role] = useState('')

  useEffect(() => {
    let login_info = cookie.load('login_info')
    if (login_info) {
      console.log(login_info.id)
      set_role(login_info.role)
    }
  }, [])

  const log_out = () => {
    let is_confirm = window.confirm('确认退出登陆？')
    if (!is_confirm) {
      return
    }
    fun['post_data'](url + 'admin_logout').then(res => console.log(res))
    cookie.remove('login_info')
    window.location.href = '/#/index_login/admin'
    window.location.reload()
  }

  return (
    <div>
      <BackTop>
        <div style={{ backgroundColor: '#1088e9', color: 'white', opacity: 0.5, width: 40, height: 40, textAlign: 'center', lineHeight: '48px' }} ><UpCircleOutlined style={{ fontSize: 25 }} /></div>
      </BackTop>
      <HashRouter>
        <div style={{}}>
          {role === '管理员' ? <div style={{ position: 'fixed', left: 0, top: 0, width: '100%', zIndex: 1000, backgroundColor: '#1ea0fa', borderBottom: '2px solid #f5f5f5', color: '#ffffff', lineHeight: '46px', textAlign: 'center', fontSize: 17, }}>
            欢迎使用：管理员<span onClick={log_out} style={{ marginLeft: 10, cursor: 'pointer' }}>点击退出登录</span>
          </div> : <div style={{ position: 'fixed', left: 0, top: 0, width: '100%', zIndex: 1000, backgroundColor: '#ffffff', borderBottom: '2px solid #f5f5f5' }}><Menu /></div>}
          <div style={{ marginTop: 50, paddingBottom: 30 }}>
            <ConfigProvider locale={zhCN}><RouterConfig /></ConfigProvider>
          </div>
        </div>
      </HashRouter>
    </div>
  );
}

export default App;